<template>
  <div class="card shadow mt-2 mb-3 border-0">
    <div class="card-body">
      <div class="title">
        <div class="wrap">
          <h5>Настройка тегов</h5>
          <div class="sub-title">Категории и тематики для анализа отзывов</div>
        </div>
        <button v-if="active_category" :disabled="!($store.getters.tariff.max_tags > categories.find(x=>x.id===active_category)?.tags.length)" class="btn btn-primary ms-auto" @click.prevent="new_tag={}">+ Добавить тег</button>
      </div>

      <ul class="nav nav-underline categories">
        <li class="nav-item" v-for="category in categories">
          <form v-if="category.edit" action="" @submit.prevent="saveCategory(category);category.edit=false;"
                class="d-flex">
            <div class="input-group">
              <input v-model="category.name" type="text" class="form-control" placeholder="Название категории">
              <button class="btn btn-primary btn-sm" type="submit" title="Сохранить"><i class="bi bi-check"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm" type="button" title="Отмена" @click="category.edit=false"><i
                  class="bi bi-x"></i></button>
            </div>
          </form>
          <template v-else>
            <a href="" :class="active_category===category.id?'active':''" data-tag="1"
               @click.prevent="active_category=category.id">{{ category.name }}</a>
            <div class="edit">
              <button class="btn" @click="category.edit=true"><i class="bi bi-pencil text-primary"></i></button>
              <button class="btn"
                      @click="delete_object={name: category.name, type: 'category', id: category.id};$modal('show', 'delete_object')">
                <i class="bi bi-trash3 text-danger"></i></button>
            </div>
          </template>
        </li>
        <li class="nav-item" v-if="add_category">
          <form action="" @submit.prevent="addCategory" class="d-flex">
            <div class="input-group">
              <input v-model="new_category.name" type="text" class="form-control" placeholder="Название категории">
              <button class="btn btn-primary btn-sm" type="submit" title="Сохранить"><i class="bi bi-check"></i>
              </button>
              <button class="btn btn-outline-danger btn-sm" type="button" title="Отмена" @click="add_category=null"><i
                  class="bi bi-x"></i></button>
            </div>
          </form>
        </li>
        <li class="nav-item" v-show="!add_category">
          <a v-if="$store.getters.tariff.max_category_tag > categories.length" href="" class="add" @click.prevent="add_category={name:''}">+</a>
        </li>

      </ul>
      <ul class="tags list-unstyled" v-for="category in categories" :data-tag="category.id"
          v-show="active_category===category.id">
        <li v-if="new_tag">
          <form class="edit-tag" @submit.prevent="addTag">
            <div class="col">
              <input v-model="new_tag.name" required placeholder="Название тега" class="form-control">
              <input v-model="new_tag.comment" required placeholder="Пояснение к тегу" class="form-control">
            </div>
            <div class="buttons">
              <button class="btn btn-primary" type="submit">Сохранить</button>
              <button class="btn btn-secondary" @click="new_tag=null">Отмена</button>
            </div>
          </form>

        </li>
        <li v-for="tag in category.tags">
          <form v-if="tag.edit" class="edit-tag" @submit.prevent="saveTag(tag);tag.edit=false;">
            <div class="col">
              <input v-model="tag.name" required placeholder="Название тега" class="form-control">
              <input v-model="tag.comment" required placeholder="Пояснение к тегу" class="form-control">
            </div>
            <div class="buttons">
              <button class="btn btn-primary" type="submit">Сохранить</button>
              <button class="btn btn-secondary" @click="tag.edit=false">Отмена</button>
            </div>
          </form>
          <template v-else>
            <div class="title">
              <div class="wrap">
                <strong>{{ tag.name }}</strong>
                <div class="sub-title">{{ tag.comment }}</div>
              </div>
            </div>

            <div class="buttons ms-auto">
              <!--            <div class="badge bg-primary">Шаблонный</div>-->
              <a href="" @click.prevent="tag.edit=true" class="text-danger">
                <i class="bi bi-pencil text-primary"></i>
              </a>
              <a href="" @click.prevent="deleteTag = {n: tag.name, c: category.id, i: tag.id};$modal('show', 'delete_tag')" class="text-danger">
                <i class="bi bi-trash3"></i>
              </a>
            </div>
          </template>
        </li>

      </ul>
    </div>
    <modal modal_id="delete_object">
      <template v-slot:header>
        <h4>Удаление объекта</h4>
      </template>
      <template v-slot:body>

        <h6 v-if="delete_object">Вы уверены, что хотите удалить "{{ delete_object.name }}"</h6>

      </template>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="$modal('hide', 'delete_object')"
                data-bs-dismiss="modal">Закрыть
        </button>
        <button type="button" class="btn btn-danger" @click="deleteCategory(delete_object.id)"
                data-bs-dismiss="modal">Удалить
        </button>
      </template>
    </modal>

    <modal modal_id="delete_tag">
        <template v-slot:header>
          <h4>Удаление тега</h4>
        </template>
        <template v-slot:body>

          <h6>Вы уверены, что хотите удалить тег "{{deleteTag?.n}}"?</h6>

        </template>
        <template v-slot:footer>
          <button type="button" class="btn btn-secondary" @click="$modal('hide', 'delete_tag')"
                  data-bs-dismiss="modal">Закрыть
          </button>
          <button type="button" class="btn btn-danger" @click="removeTag(deleteTag.c, deleteTag.i)"
                  data-bs-dismiss="modal">Удалить
          </button>
        </template>
      </modal>

  </div>

</template>

<script>

import {ProjectApi} from "@/api/projects";


export default {
  name: 'TagSettings',
  components: {},
  props: {},
  data() {
    return {
      categories: [],
      active_category: null,
      add_category: null,
      new_category: {},
      new_tag: null,
      delete_object: {name: '', type: '', id: ''},
      deleteTag: {n: '', c: '', i: ''},
    }
  },
  watch: {},
  mounted: function () {
    ProjectApi.reviews_tags(this.$store.getters.currentProjectId, 1, 200).then(response => {
      this.categories = response
      if (this.categories.length) this.active_category = this.categories[0].id
    })
  },
  computed: {
    project_id: {
      get() {
        return this.$store.getters.currentProjectId
      },
      set(value) {
      }
    }
  },

  methods: {
    addCategory() {
      ProjectApi.add_category(this.project_id, this.new_category).then(response => {
        if (response.error) {
          this.$notify({
            type: "error",
            text: response.error
          })
        } else {
          this.categories.push(response)
          this.new_category = {}
          this.add_category = null
          this.active_category = response.id
        }
      })
    },
    saveCategory(category) {
      ProjectApi.save_category(this.project_id, category).then(() => this.$notify({
            type: "success",
            text: "Сохранено"
          })
      )
    },
    deleteCategory(category_id) {
      this.$modal('hide', 'delete_object')
      ProjectApi.delete_category(this.project_id, {id: category_id}).then(() => {
            let cat_index = this.categories.findIndex(x => x.id === category_id)
            this.categories.splice(cat_index, 1)
            if (category_id === this.active_category) {
              this.active_category = this.categories[0].id
            }
            this.$notify({
              type: "success",
              text: "Удалено"
            })
          }
      )
    },
    removeTag(category_id, tag_id) {
      ProjectApi.remove_tag(this.project_id, {tag_id: tag_id}).then(response => {
        let cat = this.categories.find(c => c.id === category_id)
        let tag_index = cat.tags.findIndex(x => x.id === tag_id)
        cat.tags.splice(tag_index, 1)
        this.$modal('hide', 'delete_tag')
      })
    },
    saveTag(tag) {
      ProjectApi.save_tag(this.project_id, tag).then(response => {
        this.$notify({
          type: "success",
          text: "Сохранено"
        })

      })
    },
    addTag() {
      this.new_tag.category_id = this.active_category
      ProjectApi.add_tag(this.project_id, this.new_tag).then(response => {
        if (response.error) {
          this.$notify({
            type: "error",
            text: response.error
          })
        } else {
          this.new_tag = null;
          ProjectApi.reviews_tags(this.$store.getters.currentProjectId, 1, 200).then(response => {
            this.categories = response

          })
        }
      })
    }
  }
}

</script>
<style scoped lang="scss">
.nav-item {
  display: flex;
  align-items: baseline;

  .edit {
    display: flex;


    .btn {
      font-size: 12px;
      padding: 0;
      margin: 0;
    }
  }

  .add {
    border: 1px dashed;
    padding: 0 12px;
    font-size: 16px;
    margin-bottom: -2px;
    display: block;

  }
}

.categories {
  form {
    height: 25px;

    input {
      height: 25px;
      width: 160px;
    }

    button {
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

}

.tags {
  display: flex;
  gap: 15px;
  flex-direction: column;

  li {
    border: 1px solid var(--soft-grey);
    padding: 10px;
    width: 100%;
    display: flex;
    gap: 15px;
    align-items: center;


    .buttons {
      display: flex;
      align-items: center;
      gap: 20px;
    }
  }
}

.edit-tag {
  width: 100%;
  display: flex;
  gap: 25px;

  .col {
    gap: 10px;
    display: flex;
    flex-direction: column;

    input {
      height: 30px;
    }
  }
}

</style>

